import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from '@shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { FormWidgetInvoiceComponent } from './form-widget-invoice.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OrderModule } from 'ngx-order-pipe';
import {
    FormWidgetContractCoOwnerModule
} from '@bcm-work-flows/@form-widgets/contract-co-owner/form-widget-contract-co-owner.module';
import { BcmPipesModule } from '@modules/bcm/@shared/pipes/pipes.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NumberInputModule } from '@sharedComponents/form/number-input/number-input.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslationModule } from '@core/translation/translation.module';
import { CheckPayByCashModule } from '@sharedComponents/check-pay-by-cash/check-pay-by-cash.module';
import { NgScrollbarModule } from 'ngx-scrollbar';

@NgModule({
    declarations: [FormWidgetInvoiceComponent],
    imports: [

        FuseSharedModule,
        SharedModule,

        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        OrderModule,
        FormWidgetContractCoOwnerModule,
        BcmPipesModule,
        MatTooltipModule,
        NumberInputModule,
        DragDropModule,
        TranslationModule,
        CheckPayByCashModule,
        NgScrollbarModule
    ],
    exports: [FormWidgetInvoiceComponent]
})
export class FormWidgetInvoiceModule {
    
}
